export default function Unauthorized() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1>403 - Access Denied</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
}
